<template>
    <div class="mt-1">
        <router-view></router-view>
    </div>
</template>

<script>
  export default {
    name: 'RootView'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/RootView.vue